import { render, staticRenderFns } from "./BookingManagement.vue?vue&type=template&id=20b66669&scoped=true&lang=pug"
import script from "./BookingManagement.vue?vue&type=script&lang=js"
export * from "./BookingManagement.vue?vue&type=script&lang=js"
import style0 from "./BookingManagement.vue?vue&type=style&index=0&id=20b66669&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b66669",
  null
  
)

export default component.exports